import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {competencyById} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {projectedPremierMetricsByIdByCompetency} from '/redux/selector/metric.clients.selector';
import {withProps} from '/util/selector.util';

import PremierVolumeSection from './PremierVolumeSection';

const getCompetencyByUserId = withProps({coachId: userId})(competencyById);

export default connect(
  createStructuredSelector({
    metrics: withProps({
      coachId: userId,
      competency: getCompetencyByUserId,
    })(projectedPremierMetricsByIdByCompetency),
    currentUserCompetency: getCompetencyByUserId,
  }),
)(PremierVolumeSection);
